<template>
  <ckeditor v-model="text" :config="editorConfig" :editor="editor"></ckeditor>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/fr";

export default {
  props: { value: { type: String, required: false } },
  name: "textEditor",
  data() {
    return {
      text: this.value,
      editor: ClassicEditor,
      editorConfig: {
        language: "fr",
        toolbar: [
          "undo",
          "redo",
          "|",
          "heading",
          "bold",
          "italic",
          "numberedList",
          "bulletedList",
          "|",
          "link",
          "insertTable",
        ],
      },
    };
  },
  watch: {
    text(val) {
      this.$emit("input", val);
    },
  },
};
</script>
